import React from "react";
import { createRoot } from "react-dom/client";
import "regenerator-runtime/runtime.js";
import App from "./App";
import "./css/index.css";

const params = new URLSearchParams(window.location.search);
const subjectId = params.has("subjectId")
  ? params.get("subjectId")!
  : "missing-subject-id";
const qualtricsEmbedded = params.has("embedded")
  ? params.get("embedded") === "true"
  : false;

function onExperimentFinished() {
  console.debug("on experiment finished, posting message to survey");
  if (
    window.parent.window === undefined ||
    window.parent.window === null ||
    !qualtricsEmbedded
  ) {
    console.debug("window.parent not found, ignoring");
    return;
  }

  window.parent.window.postMessage(
    {
      event_type: "experiment_finished",
    },
    "*"
  );
}

const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <App
      subjectId={subjectId}
      onExperimentFinished={onExperimentFinished}
      // initialAppState={new PracticeSentenceState()}
    />
  </React.StrictMode>
);
